import React from 'react'
import styles from './SettingsPage.scss'
import CacheSettings from '../../components/CacheSettings'

const SettingsPage = props =>
  <div className={styles.SettingsPage}>
    <h2>Settings</h2>
    <CacheSettings />
  </div>

SettingsPage.propTypes = {}

export default SettingsPage



// WEBPACK FOOTER //
// ./src/pages/SettingsPage/SettingsPage.js